import { fetchSentimentReadings } from '@3fourteen/core';
import { useQuery } from '@tanstack/react-query';

export function useSentiment() {
  const { data: sentiment, ...rest } = useQuery({
    queryKey: ['sentiment'],
    queryFn: async () => {
      const response = await fetchSentimentReadings();
      return response;
    },
  });

  return {
    sentiment,
    ...rest,
  };
}
